import i18n from "i18next";
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from "react-i18next";
import { configuredLanguage } from "./tutorials/language";

i18n.use(HttpApi).use(initReactI18next).init({
    lng: configuredLanguage,
    fallbackLng: configuredLanguage,
    supportedLngs: ['en', 'fa'],
    interpolation: {
        escapeValue: false
    },
});

export default i18n;
